import { Bar, Line, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import './Dashboard.css';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

export default function Dashboard() {
  // Sample data for charts
  const barData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'Job Applications',
        data: [65, 59, 80, 81, 56, 55, 40],
        backgroundColor: 'rgba(79, 70, 229, 0.5)',
        borderColor: 'rgba(79, 70, 229, 1)',
        borderWidth: 1,
      },
    ],
  };

  const lineData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Profile Views',
        data: [33, 53, 85, 41, 44, 65],
        fill: true,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        tension: 0.1,
      },
    ],
  };

  const pieData = {
    labels: ['Profile Strength', 'Resume Strength', 'Skills Match'],
    datasets: [
      {
        data: [85, 75, 90],
        backgroundColor: [
          'rgba(79, 70, 229, 0.7)',
          'rgba(99, 102, 241, 0.7)',
          'rgba(129, 140, 248, 0.7)',
        ],
        borderColor: [
          'rgba(79, 70, 229, 1)',
          'rgba(99, 102, 241, 1)',
          'rgba(129, 140, 248, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const stats = [
    { name: 'Total Applications', value: '128', change: '+12%', changeType: 'increase' },
    { name: 'Interview Rate', value: '24.3%', change: '+4%', changeType: 'increase' },
    { name: 'Profile Views', value: '1,234', change: '+12.5%', changeType: 'increase' },
    { name: 'Avg. Response Time', value: '3.2 days', change: '-0.5 days', changeType: 'decrease' },
  ];

  const activities = [
    {
      id: 1,
      type: 'application',
      content: 'Applied for Senior Product Designer at Google',
      date: '2h ago',
      datetime: '2023-07-01T15:32',
    },
    {
      id: 2,
      type: 'view',
      content: 'Your profile was viewed by 12 recruiters',
      date: '1d ago',
      datetime: '2023-06-30T09:12',
    },
    {
      id: 3,
      type: 'recommendation',
      content: 'You have 3 new job recommendations',
      date: '2d ago',
      datetime: '2023-06-29T14:30',
    },
    {
      id: 4,
      type: 'connection',
      content: 'You have 5 new connection requests',
      date: '3d ago',
      datetime: '2023-06-28T11:45',
    },
  ];

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Dashboard</h1>
      
      {/* Stats Grid */}
      <div className="stats-grid">
        {stats.map((stat) => (
          <div key={stat.name} className="stat-card">
            <div className="stat-card-content">
              <div className="flex items-center">
                <div className="stat-icon-container">
                  <span>{stat.value}</span>
                </div>
                <div className="stat-details">
                  <div className="stat-name">{stat.name}</div>
                  <div className="stat-value">
                    {stat.value}
                    <span className={`stat-change ${stat.changeType}`}>
                      {stat.change}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Charts Grid */}
      <div className="charts-grid">
        <div className="chart-container">
          <h3 className="chart-title">Job Applications</h3>
          <div className="chart-wrapper">
            <Bar
              data={barData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }}
            />
          </div>
        </div>

        <div className="chart-container">
          <h3 className="chart-title">Profile Views</h3>
          <div className="chart-wrapper">
            <Line
              data={lineData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* Activity Feed */}
      <div className="activity-feed">
        <div className="activity-feed-grid">
          <div className="activity-list">
            <h3 className="chart-title">Recent Activity</h3>
            <ul>
              {activities.map((activity) => (
                <li key={activity.id} className="activity-item">
                  <div className="activity-content">
                    {activity.content}
                  </div>
                  <div className="activity-date">
                    <time dateTime={activity.datetime}>
                      {activity.date}
                    </time>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="chart-container">
            <h3 className="chart-title">Profile Strength</h3>
            <div className="chart-wrapper">
              <Pie
                data={pieData}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      position: 'right',
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
